import { Link } from 'react-router-dom';
import { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    agreed: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.agreed) {
      alert('Please agree to the terms and privacy policy.');
      return;
    }
    // Add your form submission logic here
    console.log('Form submitted:', formData);
    alert('Thank you for contacting us! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: '',
      agreed: false
    });
  };

  return (
    <>
      {/* Page Title */}
      <div className="page-title-area ptb-100">
        <div className="container">
          <div className="page-title-content">
            <h1>Contact Us</h1>
            <ul>
              <li className="item"><Link to="/">Home</Link></li>
              <li className="item"><Link to="/contact"><i className="flaticon-play-button"></i>Contact Us</Link></li>
            </ul>
          </div>
        </div>
        <div className="bg-image">
          <img src="/assets/img/page-title/contact-bg.jpg" alt="Contact Background" />
        </div>
      </div>

      {/* Contact Area */}
      <div className="contact-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="contact-info">
                <div className="info-item">
                  <i className="flaticon-smartphone"></i>
                  <div className="info-content">
                    <p>call us</p>
                    <a href="tel:+919823020019">+91 9823020019</a>
                  </div>
                </div>
                <div className="info-item">
                  <i className="flaticon-email"></i>
                  <div className="info-content">
                    <p>mail us</p>
                    <a href="mailto:info@desalepatil.in">info@desalepatil.in</a>
                  </div>
                </div>
                <div className="info-item">
                  <i className="flaticon-address"></i>
                  <div className="info-content">
                    <p></p>
                    <a href="https://maps.app.goo.gl/Uw52P3desnnfwgQV6" target="_blank" rel="noreferrer">
                      5,6, Siddhi Park, New Pandit Colony,
                      Gangapur Road, Nashik, Maharashtra
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="contact-form">
                <div className="content">
                  <h3>Get In touch</h3>
                </div>
                <form id="contactForm" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="Phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      className="form-control"
                      cols="30"
                      rows="6"
                      placeholder="Message..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <div className="form-check checkbox agree-label">
                        <input
                          name="agreed"
                          className="form-check-input"
                          type="checkbox"
                          checked={formData.agreed}
                          onChange={handleChange}
                          required
                        />
                        <label className="form-check-label" htmlFor="agreed">
                          I agree to the terms and privacy policy.
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="cta-btn">
                    <button type="submit" className="primary-btn">send message</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="contact-map">
                <iframe 
                  src="https://maps.google.com/maps?q=Desale%20Patil%20Consultancy%20Services&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Location Map"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter Section */}
      <section className="newsletter-section newsletter-two bg-primary">
        <div className="container">
          <div className="content-container">
            <div className="row">
              <div className="col-lg-6">
                <div className="newsletter-content ptb-100">
                  <h2>DOWNLOAD OUR BROCHURE</h2>
                  <form className="newsletter-form">
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Click On Download To Get PDF"
                        type="text"
                        readOnly
                      />
                      <div className="cta-btn">
                        <a className="primary-btn" target="_blank" href="/assets/dp.pdf" rel="noreferrer">
                          Download
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
